<template>
          <div class="antwoordOuter">
            <div class="antwoordInner">
              <div class="row">
                <div class="col-md-11 col-sm-11 col-xs-9">
                  <font-awesome-icon icon="chevron-square-right" />&nbsp;<span>{{ lblVerzender }} id= {{ id }}</span>
                </div>
                <div class="col-md-1 col-sm-1 col-xs-3">   
                  <div class="pull-right">      
                    <span id="antwoordReply"><font-awesome-icon icon="reply" /></span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <span id="spanOntvangers">{{ lblOntvanger }} {{ lblOntvangers }}</span>
                </div>
              </div>
              <div class="row margin10">
                <div class="col-md-11">
                  <span>{{ lblVraag }}</span>
                </div>
              </div>
              <div class="row margin10">
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <span id="spanBijlage" v-show="showBijlage"><font-awesome-icon icon="paperclip" />{{ lblBijlagen }}</span>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <span id="spanDate" class="pull-right">{{ lblDatumTijd }}</span>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'

export default {
  props: ['id'],
  mixins: [FAMixin],        
  data() {
  return {
      lblVerzender: 'Aanbieder Academisch Medisch Centrum',
      lblOntvanger: 'Ontvangers: ',
      lblOntvangers: 'GAIA-test',
      lblVraag: 'Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus.',
      lblBijlagen: ' Bijlage downloaden',
      lblDatumTijd: '12-03-2018, 09:34',
      showBijlage: true
      }
  }
}
</script>
<style>
.antwoordOuter{
  background-color: #f3f3f6;
  width: 100%;
}
.antwoordInner{
  padding: 20px 20px 10px 20px;
}
</style>
